import { Dispatch } from "react";

import { CATEGORY_ALIAS } from "../types/talk";

import createDataContext from "./createDataContext";

import { TalkCategory } from "../services/talkServices";

export type TargetCategory = {
  largeCategory?: TalkCategory;
  middleCategory?: TalkCategory;
};

export type BoardState = TargetCategory & {
  categoryList?: TalkCategory[];
  sort?: string;
  dateRange?: string;
  buildingId?: string;
  buildingName?: string;
  storeId?: string;
  isLoading?: boolean;
};

type ActionType =
  | { type: "updateCategory"; categoryInfo: BoardState }
  | { type: "loadCategory"; categoryList: TalkCategory[] }
  | {
      type: "updateField";
      values: { [key: string]: string | boolean | undefined };
    }
  | { type: "resetStoreId" };

const reducer = (state: BoardState, action: ActionType): BoardState => {
  switch (action.type) {
    case "updateCategory":
      let initSortOption;
      if (
        action.categoryInfo.middleCategory?.alias ===
        CATEGORY_ALIAS.TALK_POPULAR
      ) {
        initSortOption = {
          dateRange: "3",
          sort: undefined,
        };
      } else {
        initSortOption = {
          dateRange: undefined,
          sort: "createdAt.desc",
        };
      }

      return {
        ...state,
        ...action.categoryInfo,
        ...initSortOption,
      };
    case "loadCategory":
      return {
        ...state,
        categoryList: action.categoryList,
      };
    case "updateField":
      return {
        ...state,
        ...action.values,
      };
    case "resetStoreId":
      const { storeId, ...rest } = state;

      return {
        ...rest,
      };
    default:
      return state;
  }
};

const loadCategory = (dispatch: Dispatch<ActionType>) => {
  return async (params: { categoryList: TalkCategory[] }) => {
    await dispatch({
      type: "loadCategory",
      categoryList: params.categoryList,
    });
  };
};

const updateCategory = (dispatch: Dispatch<ActionType>) => {
  return async (params: { categoryInfo: BoardState }) => {
    await dispatch({
      type: "updateCategory",
      categoryInfo: { ...params.categoryInfo },
    });
  };
};

const updateField = (dispatch: Dispatch<ActionType>) => {
  return async (params: { [key: string]: string | undefined | boolean }) => {
    await dispatch({
      type: "updateField",
      values: params,
    });
  };
};

const resetStoreId = (dispatch: Dispatch<ActionType>) => {
  return async () => {
    await dispatch({
      type: "resetStoreId",
    });
  };
};

export const { useContext: useSandiTalk, Provider: TalkProvider } =
  createDataContext(
    reducer,
    { loadCategory, updateCategory, updateField, resetStoreId },
    { categoryList: [], isLoading: true }
  );
